import React, { useState } from "react";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";

const OxygenDeviceBundleCard = ({ data, onClick }) => {
  const [expanded, setExpanded] = useState(true);
  const selected_device = data?.selected_device || {};
  const device_type = selected_device?.device_type || {};
  const bundles = selected_device?.bundles || [];
  const toggleExpand = () => setExpanded(!expanded);
  const financierID = localStorage.getItem("allAboard-financierid") !== "undefined" && JSON.parse(localStorage.getItem("allAboard-financierid"));
  const partnerId = localStorage.getItem("allAboard-partnerid") !== "undefined" && JSON.parse(localStorage.getItem("allAboard-partnerid"));

  return (
    <div className="container my-4 pb-5">
      <div className="card shadow rounded-4 py-4">
        <h5 className="fw-bold text-center my-5">{device_type?.device_name}</h5>

        {/* Device Image + Specs Section with Shadow */}
        <div className="row mb-2 px-2">
          <div className="col-md-11 mx-auto">
            <div className="card shadow-lg rounded-4 p-3 mb-4 ">
              <div className="row px-2">
                {/* Device Image */}
                <div className="col-md-6 d-flex justify-content-center align-items-center mb-5">
                  <img
                    src={device_type?.main_photo}
                    alt={device_type?.device_name}
                    className="img-fluid rounded"
                    style={{ height: "300px", width: "100%", objectFit: "contain" }}
                  />
                </div>

                {/* Device Specs */}
                <div className="col-md-5">
                  <ul
                    style={{
                      listStyleType: '"✔ "',
                      paddingLeft: "0.2rem",
                      fontSize: "16px",
                    }}
                  >
                    <li className="py-2">
                      <strong style={{ fontSize: "15px", fontWeight: "bold" }}>
                        Data Quantity:
                      </strong>{" "}
                      {device_type?.data_qty}
                    </li>
                    {
                      (Number(financierID) !== 20 || Number(partnerId) !== 409) &&
                      <li className="py-2">
                        <strong style={{ fontSize: "15px", fontWeight: "bold" }}>
                          Voice Minutes:
                        </strong>{" "}
                        {device_type?.voice_mins} mins
                      </li>
                    }
                    {Number(device_type?.sms_qty) > 0 && (
                      <li className="py-2">
                        <strong style={{ fontSize: "15px", fontWeight: "bold" }}>
                          SMS Quantity:
                        </strong>{" "}
                        {device_type?.sms_qty}
                      </li>
                    )}
                    <li className="py-2">
                      <strong style={{ fontSize: "15px", fontWeight: "bold" }}>
                        Screen Replacement:
                      </strong>{" "}
                      {device_type?.screen_replacement}
                    </li>
                    {
                      (Number(financierID) !== 20 || Number(partnerId) !== 409) &&
                      <li className="py-2">
                        <strong style={{ fontSize: "15px", fontWeight: "bold" }}>
                          Phone Replacement:
                        </strong>{" "}
                        {device_type?.phone_replacement}
                      </li>
                    }
                    
                    <li className="py-2">
                      <strong style={{ fontSize: "15px", fontWeight: "bold" }}>
                        Custom Lock:
                      </strong>{" "}
                      {device_type?.custom_lock}
                    </li>
                    <li className="py-2">
                      <strong style={{ fontSize: "15px", fontWeight: "bold" }}>
                        Warranty Coverage:
                      </strong>{" "}
                      {device_type?.warranty_coverage}
                    </li>
                  </ul>

                  <p
                    style={{
                      fontSize: "14px",
                      fontStyle: "italic",
                      color: "#555",
                      marginTop: "10px",
                    }}
                  >
                    • <strong>RAM:</strong> {device_type?.device_ram} &nbsp; •{" "}
                    <strong>Storage:</strong> {device_type?.storage} &nbsp; •{" "}
                    <strong>Battery:</strong> {device_type?.battery}
                  </p>
                </div>

                {/* Arrow Toggle */}
                <div className="col-md-1 d-flex justify-content-center">
                  <div
                    className="d-flex justify-content-center align-items-center"
                    onClick={toggleExpand}
                    aria-label="Toggle bundles"
                  >
                    <span
                      className={`fs-4 transition-transform ${
                        expanded ? "rotate-180" : ""
                      }`}
                    >
                      {expanded ? <IoIosArrowUp /> : <IoIosArrowDown />}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <p className="text-black text-center font-weight-bold font-size-lg">
          <strong>Click the dropdown icon to show/hide device bundles…</strong>
        </p>

        {expanded && (
          <>
            <hr />
            <div className="row px-3 px-md-7">
              {bundles?.map((bundle) => (
                <div key={bundle?.id} className="col-12 col-md-6 mb-4">
                  <div className="card rounded-4 border-0 shadow-lg p-3 h-100">
                    <h6 className="fw-bold text-primary">{bundle?.bundle_name}</h6>
                    <ul className="list-unstyled small font-weight-bold px-3">
                      {
                        (Number(financierID) === 20 || Number(partnerId) === 409 )&& (
                        <li className="py-2">
                          <strong>Installment Type:</strong>{" "}
                          {bundle?.bundle_group}
                        </li>
                        )
                      }
                     {
                      Number(financierID) === 20 || Number(partnerId) === 409 ? (
                        bundle?.bundle_group?.toLowerCase() === "weekly" ? (
                          <li className="py-2">
                            <strong>Weekly Payment:</strong> ₦
                            {bundle?.weekly_payt?.toLocaleString()}
                          </li>
                        ) : bundle?.bundle_group?.toLowerCase() === "daily" ? (
                          <li className="py-2">
                            <strong>Daily Payment:</strong> ₦
                            {bundle?.daily_payt?.toLocaleString()}
                          </li>
                        ) : bundle?.bundle_group?.toLowerCase() === "monthly" ? (
                          <li className="py-2">
                            <strong>Monthly Payment:</strong> ₦
                            {bundle?.monthly_payt?.toLocaleString()}
                          </li>
                        )
                        : null
                      ) : (
                        <li className="py-2">
                          <strong>Monthly Payment:</strong> ₦
                          {bundle?.monthly_payt?.toLocaleString()}
                        </li>
                      )
                     }
                      <li className="py-2">
                        <strong>Down Payment:</strong> ₦ 
                        {bundle?.down_payt?.toLocaleString()  || 0}
                      </li>
                      <li className="py-2">
                        <strong>Duration Months:</strong> {bundle?.duration_months}
                      </li>
                      {
                        (Number(financierID) !== 20 || Number(partnerId) !== 409) &&
                        <>
                        <li className="py-2">
                          <strong>Voice Minutes:</strong> {bundle?.voice_mins} mins
                        </li>
                        </>
                      }
                      <li className="py-2">
                        <strong>Data Quantity:</strong> {bundle?.data_qty}
                      </li>
                      <li className="py-2 font-weight-light">
                        Total Repayment: ₦{bundle?.total_repayt?.toLocaleString()}
                      </li>
                    </ul>
                    <div className="mt-3 px-3 d-flex justify-content-end">
                      <button
                        className="btn btn-primary"
                        onClick={() => onClick(bundle, device_type?.id)}
                      >
                        Select
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default OxygenDeviceBundleCard;
